import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=a37b756e&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=a37b756e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37b756e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a37b756e')) {
      api.createRecord('a37b756e', component.options)
    } else {
      api.reload('a37b756e', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=a37b756e&scoped=true&", function () {
      api.rerender('a37b756e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23m9Z44veXyd5/JS/comp/DateRangeExt.vue"
export default component.exports